module.exports = {"431025100":"舜峰镇","431025101":"金江镇","431025104":"武水镇","431025105":"南强镇","431025106":"汾市镇","431025107":"水东镇","431025108":"楚江镇","431025109":"麦市镇","431025110":"香花镇","431025208":"花塘乡","431025211":"万水乡","431025214":"镇南乡","431025216":"西山瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431025.json
// module id = 2023
// module chunks = 0